/* Quick-add for storybook book cards (home + collection). Mirrors Dawn's
   product-form.js: POST the default variant to /cart/add with the drawer's
   sections, then cart.renderContents(response) updates + opens the drawer.
   Buttons: <button class="card-add" data-variant-id data-product-url>. */
(function () {
  function fail(btn) {
    var url = btn.getAttribute('data-product-url');
    if (url) window.location = url;
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) { fail(btn); return; }
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-adding');

    var config = (typeof fetchConfig === 'function')
      ? fetchConfig('javascript')
      : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = fd;

    var addUrl = (window.routes && routes.cart_add_url) ? routes.cart_add_url : '/cart/add';
    fetch(addUrl, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) { fail(btn); return; }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location = (window.routes && routes.cart_url) ? routes.cart_url : '/cart';
        }
      })
      .catch(function () { fail(btn); })
      .finally(function () {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-adding');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.card-add') : null;
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });
})();
